import { render } from "./OrderLines.vue?vue&type=template&id=90da7af2&scoped=true&ts=true"
import script from "./OrderLines.vue?vue&type=script&lang=ts"
export * from "./OrderLines.vue?vue&type=script&lang=ts"

import "./OrderLines.vue?vue&type=style&index=0&id=90da7af2&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90da7af2"]])

export default __exports__